import { render, staticRenderFns } from "./refundApplyList.vue?vue&type=template&id=524a74a8&scoped=true&"
import script from "./refundApplyList.vue?vue&type=script&lang=js&"
export * from "./refundApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a74a8",
  null
  
)

export default component.exports